import { InputText } from "primereact/inputtext";
import { SelectButton } from "primereact/selectbutton";
import { OptionCard, SectionHeader, StepBody, StepHeader, StepNav } from "./HikvisionWizardParts";

export const STREAM_TYPES = ["Main stream", "Sub stream"];

// Same URL format LiveViewCameraForm uses for Hikvision NVR channels - e.g. channel 3 main stream -> /streaming/channels/301
export const buildHikvisionRtspURL = ({ username, password, hostName, rtspPort }, channel, streamType) =>
    `rtsp://${username}:${password}@${hostName}:${rtspPort}/streaming/channels/${channel}0${streamType === "Main stream" ? 1 : 2}`;

// Fallback when the login doesn't return a channel list - matches the 16-channel grid in LiveViewCameraForm
const DEFAULT_CHANNELS = Array.from({ length: 16 }, (_, i) => ({ no: String(i + 1), name: `Channel ${i + 1}` }));

const HikvisionStepLiveView = ({
    channels, selectedLiveViewChannels, setSelectedLiveViewChannels,
    cameraName, setCameraName, streamType, setStreamType,
    onNext, onBack, isLastStep,
}) => {
    const channelChoices = channels.length > 0 ? channels : DEFAULT_CHANNELS;

    const allSelected = channelChoices.length > 0 && channelChoices.every(channel => selectedLiveViewChannels.includes(channel.no));

    const toggle = (no) => {
        setSelectedLiveViewChannels(prev => prev.includes(no) ? prev.filter(x => x !== no) : [...prev, no]);
    };

    const toggleAll = () => {
        setSelectedLiveViewChannels(allSelected ? [] : channelChoices.map(channel => channel.no));
    };

    return (
        <>
            <StepHeader title="Which channels would you like to stream?" subtitle="Selected channels will be added as live view cameras" />
            <StepBody>
                <div style={{ display: "flex", gap: "12px", alignItems: "flex-end", flexWrap: "wrap" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: 1, minWidth: "200px" }}>
                        <label htmlFor="hikvisionCameraName" style={{ fontSize: "13px", fontWeight: 600, color: "#2d2d2d" }}>NVR name</label>
                        <InputText id="hikvisionCameraName" value={cameraName} onChange={(e) => setCameraName(e.target.value)} placeholder="e.g. Front yard NVR" />
                    </div>
                    <SelectButton value={streamType} onChange={(e) => e.value && setStreamType(e.value)} options={STREAM_TYPES} />
                </div>
                <small style={{ color: "#9e9e9e" }}>Each camera is named "{cameraName || "NVR name"} - Cam &lt;channel&gt;"</small>

                <SectionHeader label="Channels" />
                <OptionCard title="Select all" selected={allSelected} onClick={toggleAll} />
                {channelChoices.map(channel => (
                    <OptionCard
                        key={channel.no}
                        title={channel.name}
                        subtitle={`Channel ${channel.no}`}
                        selected={selectedLiveViewChannels.includes(channel.no)}
                        onClick={() => toggle(channel.no)}
                    />
                ))}
            </StepBody>
            <StepNav
                onBack={onBack}
                onNext={onNext}
                nextDisabled={selectedLiveViewChannels.length === 0 || !cameraName.trim()}
                nextLabel={isLastStep ? "Link Hikvision" : "Next"}
                nextIcon={isLastStep ? "pi pi-link" : "pi pi-arrow-right"}
            />
        </>
    );
};

export default HikvisionStepLiveView;
